import * as angular from "angular";
import * as _ from "lodash";
import {SiteContextService} from "../../commons/services/site-context.service";
import {ScheduleService} from "../../schedule/services/schedule-service.service";
import {AccountModel} from "../../account/angular/models/account.model";
import {SplitService} from "../../commons/services/split-service.service";
import {ServiceType} from "../../deliveries/types/service.type";
import {EventFreqEnum} from "../../commons/angular/enums/event-freq.enum";
import {CallStopPurposeEnum} from "../enums/call-stop-purpose.enum";
import {PricePlanBundleRequestsService} from "../../price-plan/services/price-plan-bundle-requests.service";
import {OrdersService} from "../../orders/services/orders-service.service";
import {LocationType} from "../../commons/types/location.type";
import {PredefinedSkillType} from "../../skills/types/predefined-skill.type";
import {VisitConfigurationModel} from "../models/visit-configuration.model";
import {ProcessTrackingModel} from "../../commons/models/process-tracking.model";
import {ProcessTrackingStatusEnum} from "../../commons/types/process-tracking-status.enum";
import {ProcessTrackingMeasurementTypeEnum} from "../../commons/types/process-tracking-measurement-type.enum";
import {PollingIntervalService} from "../../commons/services/polling-interval.service";
import {VisitConfigurationHttpService} from "../angular/services/visit-configuration-http.service";
import {ImportVerification} from "../../commons/models/import-verification.model";

export type VisitConfigurationImportRow = Pick<ImportVerification<VisitConfigurationModel>, 'rowNumber' | 'entity'>;


export class VisitConfigurationsDialogService {

  private POLLING_INTERVAL: number = 5000;
  private BULK_EXPIRE_MAX_POLLS: number = 120; // 10 minutes, in case the process stalls

  /* @ngInject */
  constructor(private $mdDialog,
              private $log,
              private moment,
              private splitService: SplitService,
              private pricePlanBundleRequestsService: PricePlanBundleRequestsService,
              private ordersService: OrdersService,
              private siteContextService: SiteContextService,
              private visitConfigurationHttpService: VisitConfigurationHttpService
  ) {

  }

  createVisitConfiguration(serviceType, accountId?,branchIds? ,event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-visit-configuration-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, scheduleService: ScheduleService, commonsConstants, tasksConstants, $account) {

        var rrule = require('rrule');

        $scope.serviceType = serviceType;
        $scope.header = 'Create Projection Template';

        $scope.taskColorByPurpose = tasksConstants.typesToColor;
        $scope.purposeToBackgroundColor = tasksConstants.purposeToBackgroundColor;
        $scope.recurringTypes = commonsConstants.rruleTypes;
        // $scope.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');
        $scope.siteInfo = self.siteContextService.getSiteInfo();
        $scope.useLegacyServiceTime = self.splitService.getUseLegacyServiceTime();
        $scope.selectedDayOfWeek = undefined;
        $scope.ignoreTimeForServiceTemplate = true;
        $scope.loading = false;
        $scope.endRecurring = undefined;
        $scope.hasInterval = false;
        $scope.locationTypes = LocationType;

        $scope.accountId = accountId;
        $scope.branchIds = branchIds;
        $scope.isAccountSelectDisabled = !!accountId && serviceType === ServiceType.Operation;

        $scope.isEnding = false;

        $scope.visitConfiguration = {
          accountId: accountId,
          serviceType: serviceType,
          programType: undefined,
          // units: undefined,
          skills: [],
          schedule: scheduleService.getSchedulePayload(
            undefined,
            undefined,
            self.moment().startOf('day').valueOf(),
            undefined,
            EventFreqEnum.DAILY,
            1,
            self.splitService.getTimeZone()
          ),
          origin: serviceType === ServiceType.Delivery ? {
            purpose: CallStopPurposeEnum.Pickup,
            serviceTime: undefined,
            location: {
              locationType: LocationType.ACCOUNT,
              address: {}
            },
            contact: {},
            notes: undefined,
            subtasks: undefined
          } : undefined,
          destination: {
            purpose: serviceType === ServiceType.Delivery ? CallStopPurposeEnum.Dropoff : CallStopPurposeEnum.Operation,
            serviceTime: undefined,
            location: {
              locationType: LocationType.ACCOUNT,
              address: {}
            },
            contact: {},
            notes: undefined,
            subtasks: undefined
          }
        }

        $scope.openSections = {
          Pickup: false,
          Dropoff: true,
          Operation: true
        };

        $scope.addMarker = {
          enabledIndex: undefined,
          purpose: undefined
        };

        $scope.customAddressEnabled = {
          Pickup: false,
          Dropoff: false
        };

        $scope.serviceTime = undefined;
        $scope.customers = {};
        $scope.programTypes = [];

        // $scope.isRecurringTypeDisabled = true;
        // $scope.recurringType = !!recurringType ? $scope.recurringTypes.find((r) => {
        //   return r.type === recurringType;
        // }) : $scope.recurringTypes[0];

        $scope.recurringType = $scope.recurringTypes.find((r) => {
          return r.type === $scope.visitConfiguration.schedule.freq;
        })

        if ($scope.recurringType?.type !== 'DAILY') {
          $scope.visitConfiguration.schedule.byWeekDay = [];
        }

        $scope._loadOrderSettings = (selectedPricePlanType) => {

          var quoteTypes = ['TimeSlot', 'PerTask'];

          self.ordersService.getOrderSettings($scope.visitConfiguration.accountId, $scope.visitConfiguration.serviceType, selectedPricePlanType, quoteTypes)
            .then((orderSettings) => {
              var serviceRef = orderSettings;

              //Maybe needs to be in quote
              $scope.originalQuoteCopy = angular.copy(orderSettings);

              $scope.availableDays = _.get(serviceRef, 'availableDays', []);
              const today = _.find($scope.availableDays, (d) => {
                return self.moment().isSame(self.moment(d), 'day');
              })
              $scope.selectedDate = $scope.availableDays.length ? self.moment(today || _.head($scope.availableDays)).toDate() : undefined;

              $scope.visitConfiguration.skills = _.get(serviceRef, 'defaultSkills', [PredefinedSkillType.Delivery]);


              $scope.packageSizes = serviceRef.itemSizeList;

              $scope.subTaskOptionsMap = {
                [CallStopPurposeEnum.Pickup]: [],
                [CallStopPurposeEnum.Dropoff]: [],
                [CallStopPurposeEnum.Operation]: []
              }

              serviceRef.optionalSubTasks.forEach(optionalSubTask => {
                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Pickup)) {
                  $scope.subTaskOptionsMap.Pickup.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Dropoff)) {
                  $scope.subTaskOptionsMap.Dropoff.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Operation)) {
                  $scope.subTaskOptionsMap.Operation.push(optionalSubTask);
                }
              })

              $scope.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
              $scope.defaultItemSize = serviceRef.defaultItemSize;

              if ($scope.visitConfiguration.origin) {
                $scope.visitConfiguration.origin.subtasks = _.filter(serviceRef.defaultSubTasks, (defaultSubTask) => {
                  return defaultSubTask.purposes.includes($scope.visitConfiguration.origin.purpose)
                })
                $scope.visitConfiguration.origin.subtasks.forEach(st => {
                  st.actions = $scope._getSubTaskActionsWithDefaults(st);
                })
              }

              $scope.visitConfiguration.destination.subtasks = _.filter(serviceRef.defaultSubTasks, (defaultSubTask) => {
                return defaultSubTask.purposes.includes($scope.visitConfiguration.destination.purpose)
              })

              $scope.visitConfiguration.destination.subtasks.forEach(st => {
                st.actions = $scope._getSubTaskActionsWithDefaults(st);
              })

              if ($scope.useLegacyServiceTime) {
                if ($scope.visitConfiguration.origin) {
                  $scope.visitConfiguration.origin.serviceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime.generatedTotalTime', 0);
                };

                if ($scope.visitConfiguration.destination.purpose === CallStopPurposeEnum.Dropoff) {
                  $scope.visitConfiguration.destination.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime.generatedTotalTime', 0);
                }
                if ($scope.visitConfiguration.destination.purpose === CallStopPurposeEnum.Operation) {
                  $scope.visitConfiguration.destination.serviceTime = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime.generatedTotalTime', 0);
                }
              } else {
                if ($scope.visitConfiguration.origin) {
                  $scope.visitConfiguration.origin.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime', {})
                }

                if ($scope.visitConfiguration.destination.purpose === CallStopPurposeEnum.Dropoff) {
                  $scope.visitConfiguration.destination.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime', {})
                }
                if ($scope.visitConfiguration.destination.purpose === CallStopPurposeEnum.Operation) {
                  $scope.visitConfiguration.destination.serviceTime = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime', {})
                }
              }

            })
        }

        $scope._initAccount = (account: AccountModel, setModel?: boolean) => {
          $scope.pricePlanBundle = undefined;
          $scope.billingAccount = undefined;
          $scope.programTypes = [];

          $scope.visitConfiguration.accountId = account?.id;

          if (!!setModel) {
            const locationRef = $scope.visitConfiguration.serviceType === ServiceType.Delivery ?
              'origin' :
              'destination';
            $scope.onLocationAccountSelect(account, locationRef);

          }

          $scope.account = account;

          if (account) {
            $scope.account = account;
            $scope.loading = true;
            return self.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id)
              .then((pricePlanBundle) => {
                $scope.programTypes = _.filter(pricePlanBundle.entryList, 'enabled');

                var programTypeId = _.get($scope.programTypes, '[0].type')
                // $scope.recurringService.template = account ?
                //   $scope._getEmptyServiceByType(
                //     account,
                //     programTypeId,
                //     (notBefore ? notBefore : this.moment().startOf('day').valueOf()),
                //     (notAfter ? notAfter : this.moment().endOf('day').set({
                //       'minute': 45,
                //       'second': 0,
                //       'millisecond': 0
                //     }).valueOf())
                //   ) :
                //   undefined;

                // if ($scope.recurringService.template) {
                //   $scope.recurringService.template.type = 'TimeSlot';
                // }

                return self.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType($scope.visitConfiguration.accountId, $scope.serviceType || 'Delivery');
              })
              .then((defaultPricePlanTypeByServiceType) => {
                if (setModel) {
                  $scope.visitConfiguration.programType = _.get(defaultPricePlanTypeByServiceType, 'pricePlanType');
                }
                $scope._loadOrderSettings($scope.visitConfiguration.programType);
              })
              .catch((error) => {
                self.$log.info('Failed to init account @deliveriesDialogService@createSimple', error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }

        }

        if (accountId) {
          $account(accountId).$asyncValue()
            .then((account) => {
              $scope._initAccount(account, true);
            })
        }

        $scope.onIdentificationsChange = (identifications, taskRef) => {
          taskRef.taskSpec.identifications = identifications
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAccountSelect = (account: AccountModel) => {
          $scope._initAccount(account, true);
        }

        $scope.onChangePricePlan = (pricePlan) => {
          $scope.visitConfiguration.programType = pricePlan;
          $scope._loadOrderSettings(pricePlan);
        }

        $scope.onCustomerChange = (customer, purpose) => {
          $scope.customers[purpose] = customer;
        }

        $scope.isDaysSelected = () => {
          return !!$scope.selectedDayOfWeek;
        }

        $scope.onDayOfWeekChange = (dayKey) => {
          $scope.selectedDayOfWeek = dayKey;
        }

        $scope.onRecurringChange = (recurringType) => {
          $scope.recurringType = recurringType;

          if (recurringType?.type === 'WEEKLY') {
            const startTimeDay = self.moment($scope.visitConfiguration.schedule.startTime).day();
            $scope.selectedDayOfWeek = _.find(commonsConstants.daysCheckboxConfig, {dayNumber: startTimeDay})?.key;
          } else {
            $scope.selectedDayOfWeek = undefined;
            $scope.visitConfiguration.schedule.byWeekDay = [];
          }
        }
        //
        // $scope.onServiceTimeChange = (serviceTime) => {
        //   $scope.serviceTime = serviceTime;
        // }

        $scope.onChangeIsEnding = () => {
          $scope.isEnding = !$scope.isEnding;

          if ($scope.isEnding) {
            $scope.visitConfiguration.schedule.endRecurring = self.moment($scope.visitConfiguration.schedule.startRecurring).endOf('day').valueOf();
          } else {
            $scope.visitConfiguration.schedule.endRecurring = undefined;
          }
        }

        $scope.onRangeChange = (from, to) => {
          $scope.visitConfiguration.schedule.startRecurring = from;

          if ($scope.isEnding) {
            $scope.visitConfiguration.schedule.endRecurring = to;
          }

          if (!$scope.ignoreTimeForServiceTemplate) {
            $scope.visitConfiguration.schedule.startTime = from;
            $scope.visitConfiguration.schedule.endTime = to;
          }
        }

        $scope.onStartRecurringChange = (selectedDate) => {
          $scope.visitConfiguration.schedule.startRecurring = selectedDate;

          if (!$scope.ignoreTimeForServiceTemplate) {
            $scope.visitConfiguration.schedule.startTime = self.moment($scope.visitConfiguration.schedule.startRecurring).startOf('day').valueOf();
            $scope.visitConfiguration.schedule.endTime = self.moment($scope.visitConfiguration.schedule.startRecurring).endOf('day').valueOf();
          }

          if (!!$scope.isEnding &&
            $scope.visitConfiguration.schedule.startRecurring > $scope.visitConfiguration.schedule.endRecurring) {
            $scope.visitConfiguration.schedule.endRecurring = undefined;
          }
        }

        $scope.onChangeIgnoreTimeForServiceTemplate = () => {
          $scope.ignoreTimeForServiceTemplate = !$scope.ignoreTimeForServiceTemplate;

          if ($scope.ignoreTimeForServiceTemplate) {
            $scope.visitConfiguration.schedule.startTime = undefined;
            $scope.visitConfiguration.schedule.endTime = undefined;
          } else {
            $scope.visitConfiguration.schedule.startTime = self.moment($scope.visitConfiguration.schedule.startRecurring).startOf('day').valueOf();
            $scope.visitConfiguration.schedule.endTime = self.moment($scope.visitConfiguration.schedule.startRecurring).endOf('day').valueOf();
          }
        }

        $scope.onTimeTypeChange = (type) => {
          $scope.recurringService.template.type = type;
        }

        // $scope.onTaskFromTimeChange = (task, time) => {
        //   task.taskSpec.notBefore = time;
        // }

        // $scope.onTaskToTimeChange = (task, time) => {
        //   task.taskSpec.notAfter = time;
        // }

        $scope.onEndRecurringChange = (date) => {
          $scope.visitConfiguration.schedule.endRecurring = self.moment(date).endOf('day').valueOf();
        }

        $scope.onSkillsChange = (ids) => {
          $scope.visitConfiguration.skills = ids;
        }

        $scope.onTagsChange = (tagNames) => {
          // $scope.visitConfiguration.schedule.tagNames = tagNames;
        }

        $scope.onLocationButtonToggle = (isAddressButtonEnabled, task, index) => {
          isAddressButtonEnabled = !isAddressButtonEnabled;
          $scope.addMarker = {
            enabledIndex: isAddressButtonEnabled ? index : undefined,
            purpose: isAddressButtonEnabled ? task.taskSpec.purpose : undefined
          };
        }

        $scope.onToggleCustom = (task, index) => {
          var taskPurposeRef = task.taskSpec.purpose;
          $scope.customAddressEnabled[taskPurposeRef] = !$scope.customAddressEnabled[taskPurposeRef];
          var taskPurposeToDisableCustom = taskPurposeRef === 'Pickup' ? 'Dropoff' : 'Pickup';
          $scope.customAddressEnabled[taskPurposeToDisableCustom] = false;

          $scope.addMarker = {
            enabledIndex: $scope.customAddressEnabled[taskPurposeRef] ? index : undefined,
            purpose: $scope.customAddressEnabled[taskPurposeRef] ? taskPurposeRef : undefined
          };
        }

        $scope.onAddressChange = (address, isOrigin?) => {
          $scope.visitConfiguration[isOrigin ? 'origin' : 'destination'].address = address;
        }

        $scope.onLocationTypeChange = (locationType, taskType) => {
          $scope.visitConfiguration[taskType].location.locationType = locationType;
        }

        $scope.onLocationAccountSelect = (account, taskType) => {
          $scope.visitConfiguration[taskType].location.id = _.get(account, 'id');
          $scope.visitConfiguration[taskType].location.address = _.get(account, 'address');

          $scope.visitConfiguration[taskType].contact.businessName = _.get(account, 'name');
          $scope.visitConfiguration[taskType].contact.name = _.get(account, 'name');
          $scope.visitConfiguration[taskType].contact.phoneNo = _.get(account, 'phoneNumber');
          $scope.visitConfiguration[taskType].contact.additionalPhoneNo = _.get(account, 'additionalPhoneNo');

        }

        $scope.onLocationDepotSelect = (depot, taskType) => {
          $scope.visitConfiguration[taskType].location.id = _.get(depot, 'id');
          $scope.visitConfiguration[taskType].location.address = _.get(depot, 'address');

          $scope.visitConfiguration[taskType].contact.businessName = _.get(depot, 'name');
          $scope.visitConfiguration[taskType].contact.name = _.get(depot, 'contactName');
          $scope.visitConfiguration[taskType].contact.phoneNo = _.get(depot, 'phoneNumber')
          $scope.visitConfiguration[taskType].contact.additionalPhoneNo = _.get(depot, 'additionalPhoneNo');
        }

        $scope.onLocationCustomerSelect = (customer, taskType) => {
          $scope.visitConfiguration[taskType].location.id = _.get(customer, 'id');
          const address = _.find(_.get(customer, 'addresses', []), (a) => {
            return a.id === customer.defaultAddressId;
          })

          $scope.visitConfiguration[taskType].location.address = address;

          $scope.visitConfiguration[taskType].contact.customerId = _.get(customer, 'id');
          $scope.visitConfiguration[taskType].contact.name = customer ?
            _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '') :
            undefined;
          $scope.visitConfiguration[taskType].contact.businessName = _.get(customer, 'businessName');
          $scope.visitConfiguration[taskType].contact.phoneNo = _.get(customer, 'phone');
          $scope.visitConfiguration[taskType].contact.additionalPhoneNo = _.get(customer, 'additionalPhone');
          $scope.visitConfiguration[taskType].contact.email = _.get(customer, 'email');
        }

        $scope.onSubTasksChanged = (subtasks, taskType) => {
          $scope.visitConfiguration[taskType].subtasks = subtasks;
        }

        $scope.onAddSubTaskToTask = (subtask, taskType) => {
          $scope.visitConfiguration[taskType].subtasks.push(subtask);
        }

        $scope.onRemoveSubtask = (subtask, index, taskType) => {
          $scope.visitConfiguration[taskType].subtasks.splice(index, 1);
          if (!$scope.visitConfiguration[taskType].subtasks?.length) {
            $scope.visitConfiguration[taskType].subtasks = undefined;
          }
        }

        // $scope.onPackageChange = (packageItem, index) => {
        //   _.set(packageItem, 'size', packageItem.type);
        //   _.unset(packageItem, 'type');
        //
        //   const itemsCopy = angular.copy($scope.recurringService.template.packageList[0].items);
        //
        //   itemsCopy[index] = packageItem;
        //   $scope.recurringService.template.packageList[0].items = itemsCopy;
        // }

        $scope.onChangeDetailedTimeValue = (taskType, serviceTimeType, value) => {
          if (!$scope.visitConfiguration[taskType].serviceTime) {
            $scope.visitConfiguration[taskType].serviceTime = {};
          }
          $scope.visitConfiguration[taskType].serviceTime[serviceTimeType] = value;
        }

        $scope.onSubmit = (form) => {

          if (form.Pickup) {
            form.Pickup.$setSubmitted();
          }
          if (form.Dropoff) {
            form.Dropoff.$setSubmitted();
          }
          if (form.Operation) {
            form.Operation.$setSubmitted();
          }

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              var visitConfigurationCopy = angular.copy($scope.visitConfiguration);

              if ($scope.recurringType) {

                if ($scope.recurringType.type === 'WEEKLY' && !$scope.isDaysSelected()) {
                  return;
                }

                var roleTest = new rrule.RRule({
                  freq: _.get(rrule, $scope.recurringType.value),
                  dtstart: self.moment(visitConfigurationCopy.schedule.startRecurring).toDate(),
                  // until: moment($scope.timeConfig.to.date).toDate(),
                  interval: 1
                });
                visitConfigurationCopy.schedule.rrule = roleTest.toString();
                visitConfigurationCopy.schedule.interval = 1;
                visitConfigurationCopy.schedule.freq = $scope.recurringType.value.substr(6);

                visitConfigurationCopy.schedule.byWeekDay = [];
                if (visitConfigurationCopy.schedule.freq && !_.isEqual(visitConfigurationCopy.schedule.freq, 'DAILY') && $scope.selectedDayOfWeek) {
                  visitConfigurationCopy.schedule.byWeekDay = [$scope.selectedDayOfWeek];
                }

              }

              // if ($scope.serviceTime) {
              //   _.forEach(recurringServiceCopy.template.taskList, (t) => {
              //     _.set(t, 'taskSpec.serviceTime', ($scope.serviceTime * 60000)) // minutes to mili
              //   })
              // }

              self.$mdDialog.hide(visitConfigurationCopy);
            }
          }
        }

        // $scope._getEmptyServiceByType = (account, programTypeId, notBefore, notAfter) => {
        //   return $scope.serviceType === 'Delivery' ?
        //     this.ordersService.getEmptyDeliveryService(account, undefined, programTypeId, notBefore, notAfter) :
        //     this.ordersService.getEmptyOperationalService(account, undefined, programTypeId, notBefore, notAfter);
        // }


      }
    })
  }

  editVisitConfiguration(visitConfiguration: VisitConfigurationModel, branchIds?: string[] ,event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-visit-configuration-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, scheduleService: ScheduleService, commonsConstants, tasksConstants, $account) {

        var rrule = require('rrule');

        $scope.serviceType = angular.copy(visitConfiguration.serviceType);
        $scope.header = 'Update Projection Template';

        $scope.taskColorByPurpose = tasksConstants.typesToColor;
        $scope.purposeToBackgroundColor = tasksConstants.purposeToBackgroundColor;
        $scope.recurringTypes = commonsConstants.rruleTypes;
        // $scope.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');
        $scope.siteInfo = self.siteContextService.getSiteInfo();
        $scope.useLegacyServiceTime = self.splitService.getUseLegacyServiceTime();
        $scope.selectedDayOfWeek = undefined;
        $scope.ignoreTimeForServiceTemplate = !visitConfiguration.schedule?.startTime;
        $scope.loading = false;
        $scope.endRecurring = undefined;
        $scope.hasInterval = false;
        $scope.locationTypes = LocationType;

        $scope.accountId = angular.copy(visitConfiguration.accountId);
        $scope.branchIds = angular.copy(branchIds);

        $scope.isEnding = !!visitConfiguration.schedule.endRecurring;
        $scope.isAccountSelectDisabled = $scope.serviceType === ServiceType.Operation;

        $scope.visitConfiguration = angular.copy(visitConfiguration)

        // $scope.recurringType = $scope.recurringTypes.find((r) => {
        //   return r.type === visitConfiguration.schedule.freq;
        // }) || $scope.recurringTypes[0];

        $scope.recurringType = $scope.recurringTypes.find((r) => {
          return r.type === visitConfiguration.schedule.freq;
        })

        if ($scope.recurringType.type === 'WEEKLY') {
          $scope.selectedDayOfWeek = visitConfiguration.schedule?.byWeekDay?.[0];
        }

        $scope.openSections = {
          Pickup: false,
          Dropoff: true,
          Operation: true
        };

        $scope.addMarker = {
          enabledIndex: undefined,
          purpose: undefined
        };

        $scope.programTypes = [];

        // $scope.isRecurringTypeDisabled = true;
        // $scope.recurringType = !!recurringType ? $scope.recurringTypes.find((r) => {
        //   return r.type === recurringType;
        // }) : $scope.recurringTypes[0];

        // if ($scope.recurringType?.type !== 'DAILY') {
        //   const weekDays = _.filter($scope.days, (value, key) => {
        //     return value.enabled;
        //   });
        //   $scope.visitConfiguration.schedule.byWeekDay = _.map(weekDays, 'key');
        // }

        $scope._loadOrderSettings = (selectedPricePlanType, setModel: boolean) => {

          var quoteTypes = ['TimeSlot', 'PerTask'];

          self.ordersService.getOrderSettings($scope.visitConfiguration.accountId, $scope.visitConfiguration.serviceType, selectedPricePlanType, quoteTypes)
            .then((orderSettings) => {
              var serviceRef = orderSettings;

              //Maybe needs to be in quote
              $scope.originalQuoteCopy = angular.copy(orderSettings);

              $scope.availableDays = _.get(serviceRef, 'availableDays', []);
              const today = _.find($scope.availableDays, (d) => {
                return self.moment().isSame(self.moment(d), 'day');
              })
              $scope.selectedDate = $scope.availableDays.length ? self.moment(today || _.head($scope.availableDays)).toDate() : undefined;

              $scope.visitConfiguration.skills = _.get(serviceRef, 'defaultSkills', [PredefinedSkillType.Delivery]);


              $scope.packageSizes = serviceRef.itemSizeList;

              $scope.subTaskOptionsMap = {
                [CallStopPurposeEnum.Pickup]: [],
                [CallStopPurposeEnum.Dropoff]: [],
                [CallStopPurposeEnum.Operation]: []
              }

              serviceRef.optionalSubTasks.forEach(optionalSubTask => {
                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Pickup)) {
                  $scope.subTaskOptionsMap.Pickup.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Dropoff)) {
                  $scope.subTaskOptionsMap.Dropoff.push(optionalSubTask);
                }

                if (optionalSubTask.purposes.includes(CallStopPurposeEnum.Operation)) {
                  $scope.subTaskOptionsMap.Operation.push(optionalSubTask);
                }
              })

              $scope.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
              $scope.defaultItemSize = serviceRef.defaultItemSize;


              if (!!setModel) {
                if ($scope.visitConfiguration.origin) {
                  $scope.visitConfiguration.origin.subtasks = _.filter(serviceRef.defaultSubTasks, (defaultSubTask) => {
                    return defaultSubTask.purposes.includes($scope.visitConfiguration.origin.purpose)
                  })
                  $scope.visitConfiguration.origin.subtasks.forEach(st => {
                    st.actions = $scope._getSubTaskActionsWithDefaults(st);
                  })
                }

                $scope.visitConfiguration.destination.subtasks = _.filter(serviceRef.defaultSubTasks, (defaultSubTask) => {
                  return defaultSubTask.purposes.includes($scope.visitConfiguration.destination.purpose)
                })

                $scope.visitConfiguration.destination.subtasks.forEach(st => {
                  st.actions = $scope._getSubTaskActionsWithDefaults(st);
                })


                if ($scope.useLegacyServiceTime) {
                  if ($scope.visitConfiguration.origin) {
                    $scope.visitConfiguration.origin.serviceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime.generatedTotalTime', 0);
                  }

                  if ($scope.visitConfiguration.destination.purpose === CallStopPurposeEnum.Dropoff) {
                    $scope.visitConfiguration.destination.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime.generatedTotalTime', 0);
                  }
                  if ($scope.visitConfiguration.destination.purpose === CallStopPurposeEnum.Operation) {
                    $scope.visitConfiguration.destination.serviceTime = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime.generatedTotalTime', 0);
                  }
                } else {

                  if ($scope.visitConfiguration.origin) {
                    $scope.visitConfiguration.origin.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime', {})
                  }

                  if ($scope.visitConfiguration.destination.purpose === CallStopPurposeEnum.Dropoff) {
                    $scope.visitConfiguration.destination.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime', {})
                  }
                  if ($scope.visitConfiguration.destination.purpose === CallStopPurposeEnum.Operation) {
                    $scope.visitConfiguration.destination.serviceTime = _.get(serviceRef, 'serviceTimeSettings.operationDetailedServiceTime', {})
                  }
                }

              }

              // if (!$scope.recurringService.template.packageList[0].items.length) {
              //   var defaultItemSizeItem = _.find($scope.packageSizes, (p) => {
              //     return p.itemSize === serviceRef.defaultItemSize;
              //   });
              //   $scope.recurringService.template.packageList[0].items.push(
              //     {
              //       count: 1,
              //       barcode: null,
              //       size: defaultItemSizeItem.itemSize || 'NoPackage',
              //       labels: defaultItemSizeItem.labels || [],
              //       dimensions: defaultItemSizeItem.dimensions || {},
              //       weight: defaultItemSizeItem.weight
              //     }
              //   )
              // }

              // $scope.identificationOptions = {
              //   Pickup: _.mapValues(serviceRef.pickupPodSettings, (value) => {
              //     return true;
              //   }),
              //   Dropoff: _.mapValues(serviceRef.dropoffPodSettings, (value) => {
              //     return true;
              //   }),
              // };

              // var defaultPickupIdentification = _.mapValues(serviceRef.pickupPodSettings, (value) => {
              //   return _.isEqual(value, 'Required');
              // });
              //
              // var defaultDropoffIdentification = _.mapValues(serviceRef.dropoffPodSettings, (value) => {
              //   return _.isEqual(value, 'Required');
              // });

            })
        }

        $scope._initAccount = (account: AccountModel, setModel?: boolean) => {
          $scope.pricePlanBundle = undefined;
          $scope.billingAccount = undefined;
          $scope.programTypes = [];

          $scope.visitConfiguration.accountId = account?.id;

          if (!!setModel && $scope.visitConfiguration.origin) {
            $scope.onLocationAccountSelect(account, 'origin');
          }

          $scope.account = account;

          if (account) {
            $scope.account = account;
            $scope.loading = true;
            return self.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id)
              .then((pricePlanBundle) => {
                $scope.programTypes = _.filter(pricePlanBundle.entryList, 'enabled');

                var programTypeId = _.get($scope.programTypes, '[0].type')
                // $scope.recurringService.template = account ?
                //   $scope._getEmptyServiceByType(
                //     account,
                //     programTypeId,
                //     (notBefore ? notBefore : this.moment().startOf('day').valueOf()),
                //     (notAfter ? notAfter : this.moment().endOf('day').set({
                //       'minute': 45,
                //       'second': 0,
                //       'millisecond': 0
                //     }).valueOf())
                //   ) :
                //   undefined;

                // if ($scope.recurringService.template) {
                //   $scope.recurringService.template.type = 'TimeSlot';
                // }

                return self.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType($scope.visitConfiguration.accountId, $scope.serviceType || 'Delivery');
              })
              .then((defaultPricePlanTypeByServiceType) => {

                if (setModel) {
                  $scope.visitConfiguration.programType = _.get(defaultPricePlanTypeByServiceType, 'pricePlanType');
                }

                $scope._loadOrderSettings($scope.visitConfiguration.programType, setModel);
              })
              .catch((error) => {
                self.$log.info('Failed to init account @deliveriesDialogService@createSimple', error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }

        }

        if (visitConfiguration.accountId) {
          $account(visitConfiguration.accountId).$asyncValue()
            .then((account) => {
              $scope._initAccount(account);
            })
        }

        $scope.onIdentificationsChange = (identifications, taskRef) => {
          taskRef.taskSpec.identifications = identifications
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAccountSelect = (account: AccountModel) => {
          $scope._initAccount(account, true);
        }

        $scope.onChangePricePlan = (pricePlan) => {
          $scope.visitConfiguration.programType = pricePlan;
          $scope._loadOrderSettings(pricePlan);
        }

        $scope.onCustomerChange = (customer, purpose) => {
          $scope.customers[purpose] = customer;
        }

        $scope.isDaysSelected = () => {
          return !!$scope.selectedDayOfWeek;
        }

        $scope.onDayOfWeekChange = (dayKey) => {
          $scope.selectedDayOfWeek = dayKey;
        }

        $scope.onRecurringChange = (recurringType) => {
          $scope.recurringType = recurringType;

          if (recurringType?.type === 'WEEKLY') {
            const startTimeDay = self.moment($scope.visitConfiguration.schedule.startTime).day();
            $scope.selectedDayOfWeek = _.find(commonsConstants.daysCheckboxConfig, {dayNumber: startTimeDay})?.key;
          } else {
            $scope.selectedDayOfWeek = undefined;
            $scope.visitConfiguration.schedule.byWeekDay = [];
          }
        }
        //
        // $scope.onServiceTimeChange = (serviceTime) => {
        //   $scope.serviceTime = serviceTime;
        // }

        $scope.onChangeIsEnding = () => {
          $scope.isEnding = !$scope.isEnding;

          if ($scope.isEnding) {
            $scope.visitConfiguration.schedule.endRecurring = self.moment($scope.visitConfiguration.schedule.startRecurring).endOf('day').valueOf();
          } else {
            $scope.visitConfiguration.schedule.endRecurring = undefined;
          }
        }

        $scope.onRangeChange = (from, to) => {
          $scope.visitConfiguration.schedule.startRecurring = from;

          if ($scope.isEnding) {
            $scope.visitConfiguration.schedule.endRecurring = to;
          }

          if (!$scope.ignoreTimeForServiceTemplate) {
            $scope.visitConfiguration.schedule.startTime = from;
            $scope.visitConfiguration.schedule.endTime = to;
          }
        }

        $scope.onStartRecurringChange = (selectedDate) => {
          $scope.visitConfiguration.schedule.startRecurring = selectedDate;

          if (!$scope.ignoreTimeForServiceTemplate) {
            $scope.visitConfiguration.schedule.startTime = self.moment($scope.visitConfiguration.schedule.startRecurring).startOf('day').valueOf();
            $scope.visitConfiguration.schedule.endTime = self.moment($scope.visitConfiguration.schedule.startRecurring).endOf('day').valueOf();
          }

          if (!!$scope.isEnding &&
            $scope.visitConfiguration.schedule.startRecurring > $scope.visitConfiguration.schedule.endRecurring) {
            $scope.visitConfiguration.schedule.endRecurring = undefined;
          }
        }

        $scope.onChangeIgnoreTimeForServiceTemplate = () => {
          $scope.ignoreTimeForServiceTemplate = !$scope.ignoreTimeForServiceTemplate;

          if ($scope.ignoreTimeForServiceTemplate) {
            $scope.visitConfiguration.schedule.startTime = undefined;
            $scope.visitConfiguration.schedule.endTime = undefined;
          } else {
            $scope.visitConfiguration.schedule.startTime = visitConfiguration.schedule?.startTime ?
              angular.copy(visitConfiguration.schedule.startTime) :
              self.moment($scope.visitConfiguration.schedule.startRecurring).startOf('day').valueOf();
            $scope.visitConfiguration.schedule.endTime = visitConfiguration.schedule?.endTime ?
              angular.copy(visitConfiguration.schedule.endTime) :
              self.moment($scope.visitConfiguration.schedule.startRecurring).endOf('day').valueOf();
          }
        }

        $scope.onTimeTypeChange = (type) => {
          $scope.recurringService.template.type = type;
        }

        // $scope.onTaskFromTimeChange = (task, time) => {
        //   task.taskSpec.notBefore = time;
        // }

        // $scope.onTaskToTimeChange = (task, time) => {
        //   task.taskSpec.notAfter = time;
        // }

        $scope.onEndRecurringChange = (date) => {
          $scope.visitConfiguration.schedule.endRecurring = self.moment(date).endOf('day').valueOf();
        }

        $scope.onSkillsChange = (ids) => {
          $scope.visitConfiguration.skills = ids;
        }

        $scope.onTagsChange = (tagNames) => {
          // $scope.visitConfiguration.schedule.tagNames = tagNames;
        }

        $scope.onLocationButtonToggle = (isAddressButtonEnabled, task, index) => {
          isAddressButtonEnabled = !isAddressButtonEnabled;
          $scope.addMarker = {
            enabledIndex: isAddressButtonEnabled ? index : undefined,
            purpose: isAddressButtonEnabled ? task.taskSpec.purpose : undefined
          };
        }

        $scope.onToggleCustom = (task, index) => {
          var taskPurposeRef = task.taskSpec.purpose;
          $scope.customAddressEnabled[taskPurposeRef] = !$scope.customAddressEnabled[taskPurposeRef];
          var taskPurposeToDisableCustom = taskPurposeRef === 'Pickup' ? 'Dropoff' : 'Pickup';
          $scope.customAddressEnabled[taskPurposeToDisableCustom] = false;

          $scope.addMarker = {
            enabledIndex: $scope.customAddressEnabled[taskPurposeRef] ? index : undefined,
            purpose: $scope.customAddressEnabled[taskPurposeRef] ? taskPurposeRef : undefined
          };
        }

        $scope.onAddressChange = (address, isOrigin?) => {
          $scope.visitConfiguration[isOrigin ? 'origin' : 'destination'].address = address;
        }

        $scope.onLocationTypeChange = (locationType, taskType) => {
          $scope.visitConfiguration[taskType].location.locationType = locationType;
        }

        $scope.onLocationAccountSelect = (account, taskType) => {
          $scope.visitConfiguration[taskType].location.id = _.get(account, 'id');
          $scope.visitConfiguration[taskType].location.address = _.get(account, 'address');

          $scope.visitConfiguration[taskType].contact.businessName = _.get(account, 'name');
          $scope.visitConfiguration[taskType].contact.name = _.get(account, 'name');
          $scope.visitConfiguration[taskType].contact.phoneNo = _.get(account, 'phoneNumber');
          $scope.visitConfiguration[taskType].contact.additionalPhoneNo = _.get(account, 'additionalPhoneNo');

        }

        $scope.onLocationDepotSelect = (depot, taskType) => {
          $scope.visitConfiguration[taskType].location.id = _.get(depot, 'id');
          $scope.visitConfiguration[taskType].location.address = _.get(depot, 'address');

          $scope.visitConfiguration[taskType].contact.businessName = _.get(depot, 'name');
          $scope.visitConfiguration[taskType].contact.name = _.get(depot, 'contactName');
          $scope.visitConfiguration[taskType].contact.phoneNo = _.get(depot, 'phoneNumber')
          $scope.visitConfiguration[taskType].contact.additionalPhoneNo = _.get(depot, 'additionalPhoneNo');
        }

        $scope.onLocationCustomerSelect = (customer, taskType) => {
          $scope.visitConfiguration[taskType].location.id = _.get(customer, 'id');
          const address = _.find(_.get(customer, 'addresses', []), (a) => {
            return a.id === customer.defaultAddressId;
          })

          $scope.visitConfiguration[taskType].location.address = address;

          $scope.visitConfiguration[taskType].contact.customerId = _.get(customer, 'id');
          $scope.visitConfiguration[taskType].contact.name = customer ?
            _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '') :
            undefined;
          $scope.visitConfiguration[taskType].contact.businessName = _.get(customer, 'businessName');
          $scope.visitConfiguration[taskType].contact.phoneNo = _.get(customer, 'phone');
          $scope.visitConfiguration[taskType].contact.additionalPhoneNo = _.get(customer, 'additionalPhone');
          $scope.visitConfiguration[taskType].contact.email = _.get(customer, 'email');
        }

        $scope.onSubTasksChanged = (subtasks, taskType) => {
          $scope.visitConfiguration[taskType].subtasks = subtasks;
        }

        $scope.onAddSubTaskToTask = (subtask, taskType) => {
          $scope.visitConfiguration[taskType].subtasks.push(subtask);
        }

        $scope.onRemoveSubtask = (subtask, index, taskType) => {
          $scope.visitConfiguration[taskType].subtasks.splice(index, 1);
          if (!$scope.visitConfiguration[taskType].subtasks?.length) {
            $scope.visitConfiguration[taskType].subtasks = undefined;
          }
        }

        $scope.onChangeDetailedTimeValue = (taskType, serviceTimeType, value) => {
          if (!$scope.visitConfiguration[taskType].serviceTime) {
            $scope.visitConfiguration[taskType].serviceTime = {};
          }
          $scope.visitConfiguration[taskType].serviceTime[serviceTimeType] = value;
        }
        // $scope.onPackageChange = (packageItem, index) => {
        //   _.set(packageItem, 'size', packageItem.type);
        //   _.unset(packageItem, 'type');
        //
        //   const itemsCopy = angular.copy($scope.recurringService.template.packageList[0].items);
        //
        //   itemsCopy[index] = packageItem;
        //   $scope.recurringService.template.packageList[0].items = itemsCopy;
        // }

        $scope.onSubmit = (form) => {

          if (form.Pickup) {
            form.Pickup.$setSubmitted();
          }
          if (form.Dropoff) {
            form.Dropoff.$setSubmitted();
          }
          if (form.Operation) {
            form.Operation.$setSubmitted();
          }

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              var visitConfigurationCopy = angular.copy($scope.visitConfiguration);

              if ($scope.recurringType) {

                if ($scope.recurringType.type === 'WEEKLY' && !$scope.isDaysSelected()) {
                  return;
                }

                var roleTest = new rrule.RRule({
                  freq: _.get(rrule, $scope.recurringType.value),
                  dtstart: self.moment(visitConfigurationCopy.schedule.startRecurring).toDate(),
                  // until: moment($scope.timeConfig.to.date).toDate(),
                  interval: 1
                });
                visitConfigurationCopy.schedule.rrule = roleTest.toString();
                visitConfigurationCopy.schedule.interval = 1;
                visitConfigurationCopy.schedule.freq = $scope.recurringType.value.substr(6);

                visitConfigurationCopy.schedule.byWeekDay = [];
                if (visitConfigurationCopy.schedule.freq && !_.isEqual(visitConfigurationCopy.schedule.freq, 'DAILY') && $scope.selectedDayOfWeek) {
                  visitConfigurationCopy.schedule.byWeekDay = [$scope.selectedDayOfWeek];
                }

              }

              // if ($scope.serviceTime) {
              //   _.forEach(recurringServiceCopy.template.taskList, (t) => {
              //     _.set(t, 'taskSpec.serviceTime', ($scope.serviceTime * 60000)) // minutes to mili
              //   })
              // }

              self.$mdDialog.hide(visitConfigurationCopy);
            }
          }
        }

        // $scope._getEmptyServiceByType = (account, programTypeId, notBefore, notAfter) => {
        //   return $scope.serviceType === 'Delivery' ?
        //     this.ordersService.getEmptyDeliveryService(account, undefined, programTypeId, notBefore, notAfter) :
        //     this.ordersService.getEmptyOperationalService(account, undefined, programTypeId, notBefore, notAfter);
        // }


      }
    })
  }

  expireVisitConfigurations(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/expire-visit-configurations-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {
        $scope.expirationDate = undefined;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onDateChange = (selectedDate) => {
          $scope.expirationDate = selectedDate;
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {
            self.$mdDialog.hide($scope.expirationDate);
          }
        }
      }
    })
  }

  expireVisitConfigurationsProcessing(processTracking: ProcessTrackingModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/expire-visit-configurations-processing-dialog.html').default,
      clickOutsideToClose: false,
      escapeToClose: false,
      controller: function ($scope, pollingIntervalService: PollingIntervalService) {

        $scope.processTracking = processTracking;
        $scope.progress = self._getBulkExpireProgress(processTracking);
        $scope.isProcessDone = self._isBulkExpireProcessDone(processTracking);

        let attempts: number = 0;

        const poller = pollingIntervalService.start($scope, () => {
          if (!$scope.isProcessDone && attempts < self.BULK_EXPIRE_MAX_POLLS) {
            attempts++;
            $scope._getProcess();
          } else {
            poller.cancel();
            self.$mdDialog.hide({processTracking: $scope.processTracking, isDone: !!$scope.isProcessDone});
          }
        }, self.POLLING_INTERVAL);

        $scope._getProcess = () => {
          self.visitConfigurationHttpService.getProcessTracking([processTracking.id])
            .subscribe({
              next: (processTrackingList: ProcessTrackingModel[]) => {
                const process: ProcessTrackingModel = _.find(processTrackingList, {id: processTracking.id});

                $scope.processTracking = process || $scope.processTracking;
                $scope.progress = self._getBulkExpireProgress($scope.processTracking);
                $scope.isProcessDone = self._isBulkExpireProcessDone($scope.processTracking);

                if (!$scope.isProcessDone) {
                  return;
                }

                poller.cancel();
                self.$mdDialog.hide({processTracking: $scope.processTracking, isDone: !!$scope.isProcessDone});
              },
              error: (err) => {
                self.$log.error('Failed to get bulk expire projection templates process tracking', err);

                poller.cancel();
                self.$mdDialog.cancel(err);
              }
            })
        }
      }
    })
  }

  private _getBulkExpireProgress(processTracking: ProcessTrackingModel): number {
    const measurement = processTracking?.progressMap?.[ProcessTrackingMeasurementTypeEnum.CallTemplates];
    const total = measurement?.total || 0;

    if (!total) {
      return 0;
    }

    return ((measurement.updated || 0) + (measurement.failed || 0)) / total * 100;
  }

  // The process status is not flipped to COMPLETED by the server, so the progress counters determine when it is done.
  private _isBulkExpireProcessDone(processTracking: ProcessTrackingModel): boolean {
    if (!processTracking || processTracking.processStatus === ProcessTrackingStatusEnum.FAIL) {
      return true;
    }

    const measurement = processTracking.progressMap?.[ProcessTrackingMeasurementTypeEnum.CallTemplates];

    if (!measurement?.total) {
      return false;
    }

    return ((measurement.updated || 0) + (measurement.failed || 0)) >= measurement.total;
  }

  reviewUploadedVisitConfigurations(rows: ImportVerification<VisitConfigurationModel>[], event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/visit-configuration-upload-recap-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      // md-virtual-repeat measures the container before the dialog finished animating open,
      // so it under-renders unless it re-measures once the dialog reached its final size.
      onComplete: (scope) => {
        scope.$broadcast('$md-resize');
      },
      controller: function ($scope) {

        const setRows = (rows: ImportVerification<VisitConfigurationModel>[]) => {
          $scope.rows = rows;
          $scope.pendingRows = rows.filter((row: any) => row.__pending);
          $scope.validRows = rows.filter((row: any) => !row.__pending && (!row.mappingErrors || !row.mappingErrors.length));
          $scope.invalidRows = rows.filter((row: any) => !row.__pending && row.mappingErrors && row.mappingErrors.length);
        };

        setRows(angular.copy(rows));

        $scope.queryString = '';
        $scope.statusFilter = 'All';
        $scope.callTypeFilter = 'All';

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
        };

        $scope.onDeleteRow = (row) => {
          setRows($scope.rows.filter(r => r.rowNumber !== row.rowNumber));
        };

        $scope.onRowEdited = () => {
          // New array reference so the table's one-way `rows` binding sees the change.
          setRows($scope.rows.slice());
        };

        $scope.submit = () => {
          // The table decorates its rows in place, so drop everything the importer doesn't need.
          const rowsToUpload: VisitConfigurationImportRow[] = $scope.validRows.concat($scope.pendingRows)
            .map(({rowNumber, entity}) => ({rowNumber, entity}));

          self.$mdDialog.hide(rowsToUpload);
        };

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        };
      }
    });
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .service('visitConfigurationsDialogService', VisitConfigurationsDialogService);
